import loop from './render-loop';

export default function animate(duration, step, ease) {

    if (!ease) {
        ease = function (progress) {
            return progress;
        };
    }

    return function () {
        return new Promise(function (resolve) {
            var progress = 0;
            loop(function (delta) {
                progress += delta;
                step(ease(Math.min(1, Math.max(0, progress / duration))));

                if (progress >= duration) {
                    resolve();
                    return false;
                }
                return true;
            });
        });
    };
}
